import { LoadableElement } from '@99designs/common/components/LoadableElement';
import { getBriefType_structuredBrief } from '__generated__/getBriefType';
import { ApolloQueryResult } from 'apollo-client/core/types';
import { handleGraphQLError } from 'common/utils/Apollo';
import { DocumentNode } from 'graphql';
import { errorNotFound, errorServerError } from 'projects/components/ErrorBoundary';
import { BriefFieldsRedirect } from 'projects/routes';
import React from 'react';
import { Query } from 'react-apollo';

type BriefFieldsTypename = getBriefType_structuredBrief['fields']['__typename'];

interface BaseQuery {
    brief: {
        id: string;
        fields: {
            __typename: BriefFieldsTypename;
        };
    };
}

export default function BriefQuery<TQueryData extends BaseQuery, TQueryVariables>(props: {
    query: DocumentNode;
    variables: TQueryVariables;
    fieldsTypename: BriefFieldsTypename;
    children: (
        data: TQueryData,
        refetch: (variables: TQueryVariables) => Promise<ApolloQueryResult<TQueryData>>
    ) => JSX.Element;
}) {
    return (
        <Query<TQueryData> query={props.query} variables={props.variables}>
            {({ data, error, loading, refetch }) => {
                if (loading) {
                    return <LoadableElement variations={['fade-in']} isLoading={true} />;
                }

                if (error) {
                    handleGraphQLError(error);
                }

                if (!data) {
                    throw errorServerError;
                }

                if (!data.brief) {
                    throw errorNotFound;
                }

                if (data.brief.fields.__typename !== props.fieldsTypename) {
                    return <BriefFieldsRedirect brief={data.brief} />;
                }

                return props.children(data, refetch);
            }}
        </Query>
    );
}
